export default __webpack_public_path__ + "static/media/标题-简介@2x.fe202fb0.png";